import React, { useState, useEffect } from "react";
import PromotionCard from "../../../../../components/common/PromotionCard";
import { connect } from "react-redux";
import PromotionHeader from "../../../../../components/common/PromotionHeader";
import {
  MANAGEMENT_SELECTED_REGION_FIELD,
  MANAGEMENT_PROMOTION_UPDATE_FIELD,
} from "../../../../../constants/actionTypes";
import Loader from "../../../../../components/Loader";
import { fixTimezoneOffset } from "../../../../../functions/dateConverter";
let date = new Date();

const mapStateToProps = (state) => {
  return {
    promotions: state.promotions,
    prices: state.promotions.selectedProduct?.Prices,
  };
};
const mapDispatchToProps = (dispatch) => ({
  onChangePrice: (price) => {
    dispatch({
      type: MANAGEMENT_SELECTED_REGION_FIELD,
      value: price,
    });
    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "changePercentage",
      value: [],
    });
    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "calculatedAverage",
      value: null,
    });

    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "setOS",
      value: [],
    });
    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "setPlatforms",
      value: [],
    });

    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "tier1Price",
      value: 0,
    });

    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "tier2Price",
      value: 0,
    });
    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "tier3Price",
      value: 0,
    });
    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "minQuantity",
      value: 1,
    });
    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "maxQuantity",
      value: 1000,
    });
    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "validTo",
      value: fixTimezoneOffset(
        new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          23,
          30,
          0,
          0
        ).setMinutes(30)
      ),
    });
    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "validFrom",
      value: fixTimezoneOffset(new Date().setMinutes(30)),
    });
    dispatch({
      type: MANAGEMENT_PROMOTION_UPDATE_FIELD,
      key: "checkPromotion",
      value: false,
    });
  },
});

function SelectRegions(props) {
  const [isLoading, setLoading] = useState(true);
  const [regions, setRegions] = useState();

  useEffect(() => {
    setRegions(props.prices?.sort((a, b) => a.Cost - b.Cost));
    setLoading(false);
  }, [props.prices]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="container-fluid">
            <div className="row">
              <PromotionHeader
                product={props.selectedProduct?.Name}
                title="Select Regions"
                goToSelectGame={() => props.GoToSelectGame()}
              />
              <div className="d-flex flex-row justify-content-center mb-3">
                <div className="select-region-cards-container row">
                  {regions?.map((item, key) => {
                    return (
                      <div
                        className="d-flex justify-content-center col p-0 mt-1"
                        key={key}
                      >
                        <PromotionCard
                          item={item}
                          region={{ regions: item.Countries }}
                          id={key + 1}
                          key={key + 1}
                          selected={
                            props.promotions.selectedRegion.filter(
                              (f) => f.Id === item.Id
                            ).length > 0
                              ? true
                              : false
                          }
                          changePrice={(Id) => {
                            props.onChangePrice(item);
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(SelectRegions);
